<template>
  <span :style="styleObject" class="block px-2 py-1 text-gray-900">
    {{ value }}
  </span>
</template>

<script>
import * as d3 from 'd3';
import tailwindConfig from '../mixins/tailwindConfig';

export default {
  mixins: [tailwindConfig],

  props: {
    value: {
      type: [Number, String],
      required: true,
    },
  },

  computed: {
    styleObject() {
      return {
        backgroundColor: this.getColorFromRange(this.value),
      };
    },
  },

  methods: {
    getColorFromRange(value) {
      const getColor = d3.scaleLinear()
        .domain([-5, 0, 5])
        .range([
          this.twColors.red['300'],
          '#FFF',
          this.twColors.blue['400'],
        ])
        .clamp(true);

      return getColor(value);
    },
  },
};
</script>
